import {
  MemberListViewModel_default
} from "./chunk-KSKU5BSR.js";
import {
  MemberDetailViewModel_default
} from "./chunk-K2DQOACP.js";
import {
  __publicField
} from "./chunk-G2CEMTG6.js";

// src/pages/Members/MemberViewModel/MemberViewModel.ts
var MemberViewModel = class {
  constructor(memberStore) {
    __publicField(this, "memberDetailViewModel", {});
    __publicField(this, "memberListViewModel", {});
    __publicField(this, "getMemberDetailViewModel", () => this.memberDetailViewModel);
    __publicField(this, "getMemberListViewModel", () => this.memberListViewModel);
    if (memberStore) {
      this.memberDetailViewModel = new MemberDetailViewModel_default(memberStore);
      this.memberListViewModel = new MemberListViewModel_default(memberStore);
    }
  }
};
var MemberViewModel_default = MemberViewModel;

export {
  MemberViewModel_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
